import { render, staticRenderFns } from "./SidebarHorizon.vue?vue&type=template&id=10c0688c"
import script from "./SidebarHorizon.vue?vue&type=script&lang=js"
export * from "./SidebarHorizon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c0688c')) {
      api.createRecord('10c0688c', component.options)
    } else {
      api.reload('10c0688c', component.options)
    }
    module.hot.accept("./SidebarHorizon.vue?vue&type=template&id=10c0688c", function () {
      api.rerender('10c0688c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/SidebarHorizon.vue"
export default component.exports